import genererMail from '@/services/general/genererMail';
import { get as getTiers } from '@/api/tiers/index';
import { convertTierToMail } from '@/services/dcf/generationMail';

export default async function generationMailPourOtAffichage(destinataireId, user) {
  const mail = genererMail();
  if (destinataireId !== null) {
    const destinataire = (await getTiers(destinataireId)).data.result;
    if (destinataire && destinataire.email) mail.to.push(convertTierToMail(destinataire));
  }
  if (user.email) mail.from = user.email;
  return mail;
}
